import { createFileRoute } from '@tanstack/react-router';
import { ShipmentPage } from '../../features/shipments';

export const Route = createFileRoute('/portal/shipments/$id')({
  component: function ShipmentRoute() {
    const { id } = Route.useParams();
    return <ShipmentPage id={id} />;
  },
});
